import { CardView } from "common/views/card/Card.view";
import { Fragment } from "core/components/FragmentProvider";

export const card: Fragment<any> = {
	name: "Card",
	component: ({ children }) => (
		<CardView viewKey="articleList.item">{children}</CardView>
	)
};



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/fragments/container/itemContainerFragments.tsx